import color from "constants/color";
import { LiHTMLAttributes } from "react";
import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 20px;
  background-color: #ffffff;
  border-radius: 6px;
  padding: 20px;
  box-sizing: border-box;
  .disabled {
    opacity: 0.7;
  }
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  .misc {
    display: flex;
    gap: 10px;
    align-items: center;
  }
`;

export const OnPress = styled.div<{ disabled?: boolean }>`
  height: 36px;
  min-width: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 3px;
  border: 1px solid #e0e0e0;
  width: 36px;
  position: relative;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  ${({ disabled }) => (disabled ? "opacity: 0.7;" : "")}
  background-color: ${({ disabled }) => (disabled ? "#e0e0e0" : "white")};
`;

export const FiltersCount = styled.span`
  position: absolute;
  top: -5px;
  right: -5px;
  background: ${color.error};
  width: 16px;
  height: 16px;
  border-radius: 100%;
  font-family: Inter;
  font-style: normal;
  font-weight: 400;
  font-size: 8px;
  line-height: 10px;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100px;
  width: 100%;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  border: 1px solid rgb(224, 224, 224);
`;

export const TableContainer = styled.div`
  width: 100%;
  border: 1px;
`;

export const TableBody = styled.div`
  width: 100%;
`;

export const TableHeader = styled.div`
  display: grid;
  grid-template-columns: 1.3fr 2.55fr 1.5fr 1.5fr 2.55fr 0.6fr;
  padding: 10px;

  font-size: 16px;
  color: #ababab;
  font-weight: 500;
  font-family: Inter;
  white-space: nowrap;
`;

export const TableContent = styled.div`
  max-height: fit-content;
  width: 100%;
  overflow-y: hidden !important;

  &::-webkit-scrollbar {
    width: 5px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  &::-webkit-scrollbar-thumb {
    background: #d5d5d5;
    border-radius: 8px;
  }
`;

interface TableItemProps extends LiHTMLAttributes<HTMLLIElement> {
  first?: boolean;
  last?: boolean;
  background?: string;
  loading?: boolean;
}

export const TableItem = styled.li.withConfig({
  shouldForwardProp: (prop) =>
    !["loading", "first", "last", "background"].includes(prop),
})<TableItemProps>`
  display: grid;
  grid-template-columns: 1.3fr 2.55fr 1.5fr 1.5fr 2.55fr 0.6fr;
  align-items: center;
  border-top: ${({ first }) => (first ? "1px solid #EAECF0" : "none")};
  border-bottom: 1px solid #eaecf0;
  border-bottom-left-radius: ${({ last }) => (last ? "12px" : "0")};
  border-bottom-right-radius: ${({ last }) => (last ? "12px" : "0")};
  font-family: Inter;
  background: ${({ background }) => background};
  font-size: 16px;
  padding: 10px;
`;
